/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { StatisticByCategoryList } from '../models/statistic-by-category-list';
import { StatisticByStateList } from '../models/statistic-by-state-list';
import { statisticsByCategory } from '../fn/statistics/statistics-by-category';
import { StatisticsByCategory$Params } from '../fn/statistics/statistics-by-category';
import { statisticsByState } from '../fn/statistics/statistics-by-state';
import { StatisticsByState$Params } from '../fn/statistics/statistics-by-state';


/**
 * Statistics of the stations
 */
@Injectable({ providedIn: 'root' })
export class StatisticsService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `statisticsByCategory()` */
  static readonly StatisticsByCategoryPath = '/custom/stations/statisticsByCategory';

  /**
   * Get the statistics by the category of the stations.
   *
   * Get the statistics by the category of the stations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsByCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsByCategory$Response(params?: StatisticsByCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<StatisticByCategoryList>> {
    return statisticsByCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the statistics by the category of the stations.
   *
   * Get the statistics by the category of the stations.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsByCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsByCategory(params?: StatisticsByCategory$Params, context?: HttpContext): Observable<StatisticByCategoryList> {
    return this.statisticsByCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatisticByCategoryList>): StatisticByCategoryList => r.body)
    );
  }

  /** Path part for operation `statisticsByState()` */
  static readonly StatisticsByStatePath = '/custom/stations/statisticsByState';

  /**
   * Get the statistics by the state of the stations.
   *
   * Get the statistics by the state of the stations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsByState()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsByState$Response(params?: StatisticsByState$Params, context?: HttpContext): Observable<StrictHttpResponse<StatisticByStateList>> {
    return statisticsByState(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the statistics by the state of the stations.
   *
   * Get the statistics by the state of the stations.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsByState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statisticsByState(params?: StatisticsByState$Params, context?: HttpContext): Observable<StatisticByStateList> {
    return this.statisticsByState$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatisticByStateList>): StatisticByStateList => r.body)
    );
  }

}
